// extracted by mini-css-extract-plugin
export default {"description":"description-module___description___e3ebe5ba"};